import { useRoutes } from 'react-router-dom';
import { generateRouteList } from './route';
import useUserStore from '../store/user';
import { useMemo } from 'react';
import type { ReactElement } from 'react';

export const RenderRouter = (): ReactElement | null => {
  // 监听菜单数据变化
  const { menuList } = useUserStore();

  // 当菜单数据变化时重新生成路由配置
  const routes = useMemo(() => {
    const routeConfig = generateRouteList();
    return routeConfig;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [menuList]);

  return useRoutes(routes);
};
